/**
 * Horizontal scrollable row of selectable option pills.
 * Uses staggered spring entrance with hover/tap micro-interactions.
 */

import React from 'react';
import { motion } from 'framer-motion';
import { chipContainerVariants, chipVariants } from './animations';

interface Props {
  options: string[];
  onSelect: (option: string) => void;
}

const OptionPills: React.FC<Props> = ({ options, onSelect }) => {
  if (options.length === 0) return null;

  return (
    <motion.div
      variants={chipContainerVariants}
      initial="initial"
      animate="animate"
      className="flex flex-wrap gap-2 px-1"
    >
      {options.map((option) => (
        <motion.button
          key={option}
          variants={chipVariants}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          onClick={() => onSelect(option)}
          className="rounded-full border border-border/60 bg-card px-3.5 py-1.5 text-xs font-medium text-heading transition-colors hover:border-primary/40 hover:bg-primary/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {option}
        </motion.button>
      ))}
    </motion.div>
  );
};

export default OptionPills;
